
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 18","data-token-name":"ghost"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.167 15.033c0 .228-.065.45-.187.64s-.296.337-.499.424c-.203.087-.426.11-.641.066a1.1 1.1 0 01-.569-.315l-.652-.675a1.075 1.075 0 00-1.57 0l-1.763 1.49a1.075 1.075 0 01-1.57 0l-1.764-1.49a1.074 1.074 0 00-1.57 0l-.652.675a1.075 1.075 0 01-1.21.25 1.121 1.121 0 01-.498-.425 1.184 1.184 0 01-.188-.64V7.917c0-1.834.702-3.594 1.953-4.891A6.546 6.546 0 017.5 1c1.768 0 3.463.729 4.714 2.026a7.052 7.052 0 011.952 4.891v7.116z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"5.168","cy":"8","r":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"9.834","cy":"8","r":"1","fill":"currentColor"}})])
          )
        }
      }
    